import { ModuleBase } from "@/modules/base";
import { Component, Mixins } from 'vue-property-decorator';
import ImageCutoutWindow from "./ImageCutoutWindow/index.vue";
import AnalysisMenu from './AnalysisMenu.vue'

@Component
export class ImageCutoutModule extends Mixins(ModuleBase) {
  showWindow = false

  get outlet() {
    return {
      window: ImageCutoutWindow,
      analysisMenu: AnalysisMenu,
    }
  }
}
